module.exports = __webpack_public_path__ + "static/media/face2.e77174df.jpg";